import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { internalLayerVersionsKeys } from './queryKeys';

export function useDeleteDraftInternalLayerVersionMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, { internalLayerVersionId: UUID }>({
    mutationFn: async ({ internalLayerVersionId }) => {
      await axios.delete(
        `${config.apiGateway.internal_layer_versions}/${internalLayerVersionId}/draft`
      );
    },
    onSuccess: () => {
      toast.success('Draft internal layer version deleted');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });
    },
  });
}
